import styled from 'styled-components'
import { orange, black, textMuted, mutedGrey, surface2, border2 } from '@/theme/colors'
import { radii, motion } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { Range } from '@components/Field'

export const DropZone = styled.div`
    border: 2px dashed ${border2};
    border-radius: ${radii.inner};
    padding: 40px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    cursor: pointer;
    transition: border-color ${motion.base}, background ${motion.base};
    background: ${surface2};

    &:hover {
        border-color: ${orange};
        background: ${orange}14;
    }
`

export const DropZoneIcon = styled.div`
    width: 48px;
    height: 48px;
    color: ${mutedGrey};

    svg {
        width: 100%;
        height: 100%;
    }
`

export const DropZoneText = styled.p`
    margin: 0;
    font-size: ${fontSizes.base};
    color: ${textMuted};
    text-align: center;
    line-height: ${leading.body};

    strong {
        color: ${orange};
    }

    span {
        font-size: ${fontSizes.caption};
        color: ${mutedGrey};
    }
`

export const CropWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`

export const CropArea = styled.div`
    position: relative;
    width: 100%;
    height: 288px;
    border-radius: ${radii.inner};
    overflow: hidden;
    background: ${black};
`

export const CropHint = styled.p`
    margin: 0;
    font-size: ${fontSizes.micro};
    color: ${mutedGrey};
    text-align: center;
`

export const ZoomSliderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const ZoomSliderLabel = styled.span`
    font-size: ${fontSizes.caption};
    color: ${textMuted};
    font-weight: 500;
    flex-shrink: 0;
`

export const ZoomSlider = styled(Range)`
    flex: 1;
`

export const CropActions = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 16px;
    justify-content: flex-end;
`

export const CropButton = styled(Button)``

